import tippy from 'tippy.js';

export const tippyHelper = () => {
    document.querySelectorAll('[js-tippy]').forEach(element => {
        if (element.closest('.apartments-list')) return;

        tippy(element, {
            content: element.getAttribute('js-tippy'),
            allowHTML: true,
        });
    });

    document.querySelectorAll('[js-tippy-click]').forEach(element => {
        if (element.closest('.apartments-list')) return;

        tippy(element, {
            content: element.getAttribute('js-tippy-click'),
            allowHTML: true,
            trigger: 'click',
        });
    });
};
